export default __webpack_public_path__ + "static/media/023f02d6545e1d74f00a7eb859cdb103.svg";